export const searchOkta = `
  query SearchOkta($search: String!) {
    searchOkta(search: $search)
  }
`;
